import script from "./ValidateMixin.vue?vue&type=script&lang=js"
export * from "./ValidateMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__